/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Check.
 * @export
 */
export const ICON_CHECK = (
  <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.32852 13.2276L4.43716 10.3363C4.28148 10.1802 4.07013 10.0925 3.84972 10.0925C3.62931 10.0925 3.41796 10.1802 3.26228 10.3363C2.93731 10.6612 2.93731 11.1862 3.26228 11.5111L6.74525 14.9941C7.07021 15.3191 7.59516 15.3191 7.92012 14.9941L16.7359 6.17835C17.0608 5.85339 17.0608 5.32844 16.7359 5.00348C16.5802 4.84745 16.3688 4.75977 16.1484 4.75977C15.928 4.75977 15.7167 4.84745 15.561 5.00348L7.32852 13.2276Z"
      fill="#707070"
    />
  </svg>
);
